// extracted by mini-css-extract-plugin
export default {"text-custom-vars":"text-custom-vars__KvJwr"};